<template>
  <div class="modal-wrapper" @click.self="$emit('close')">
    <div class="modal" @click="closeAllDDs">
      <header>
        <div>
          <span class="tms">0</span>
        </div>
        <p>ИЗБЕРИ ГРУПА/СЛУЖИТЕЛИ</p>
        <span class="tms close" @click="$emit('close')">F</span>
      </header>
      <main>
        <div class="row">
          <section>
            <Checkbox
              v-model="showGroups"
              label="Групи ВАС"
              @input="resetSelected(groups, !$event)"
            />
            <Dropdown
              :disabled="!showGroups"
              :list="usersAndGroups.groups"
              :alwaysFocused="true"
            />
          </section>

          <section>
            <Checkbox
              v-model="showWorkerGroups"
              label="Групи подизпълнители"
              @input="resetSelected(workerGroups, !$event)"
            />
            <Dropdown
              :disabled="!showWorkerGroups"
              :list="workerGroups"
              :alwaysFocused="true"
            />
          </section>

          <section>
            <Checkbox
              v-model="showUsers"
              label="Служители"
              @input="resetSelected(users, !$event)"
            />
            <Dropdown
              :disabled="!showUsers"
              :list="usersAndGroups.users"
              :alwaysFocused="true"
            />
          </section>
        </div>
      </main>
      <footer>
        <button
          :disabled="
            loading || (!selectedGroups.length && !selectedUsers.length)
          "
          @click="save"
        >
          ЗАПАЗИ
        </button>
      </footer>
    </div>
  </div>
</template>

<script>
import Checkbox from "./Checkbox.vue";
import Dropdown from "./Dropdown.vue";
export default {
  props: ["planning"],
  components: {
    Checkbox,
    Dropdown,
  },
  data() {
    return {
      groups: [],
      workerGroups: [],
      users: [],
      dd: null,
      showGroups: true,
      showWorkerGroups: true,
      showUsers: true,
      loading: false,
      search: "",
      searchFocused: false,
    };
  },
  computed: {
    usersAndGroups() {
      for (let g of this.groups) {
        let selectedGroupUsers = 0;
        g.users.forEach((u) => {
          this.users.find((us) => {
            // set group disable
            if (us.group && us.group._id.toString() === g._id.toString()) {
              if (us.selected) selectedGroupUsers++;
              if (selectedGroupUsers > 1) this.$set(g, "disabled", true);
              else this.$set(g, "disabled", false);
            }

            // set user disable
            if (us._id.toString() === u._id.toString()) {
              if (g.selected) this.$set(us, "disabled", true);
              else this.$set(us, "disabled", false);
            }
          });
        });
      }

      return { users: this.users, groups: this.groups };
    },
    selectedGroups() {
      const output = [];

      for (let g of this.groups) {
        if (g.selected) output.push(g);
      }
      for (let g of this.workerGroups) {
        if (g.selected) output.push(g);
      }

      return output;
    },
    selectedUsers() {
      const output = [];

      for (let u of this.users) {
        if (u.selected) output.push(u);
      }

      return output;
    },
  },
  methods: {
    resetSelected(arr, reset) {
      if (reset) {
        arr.map((a) => (a.selected = false));
      }
    },
    closeAllDDs() {
      this.dd = null;
    },
    getGroups() {
      let url = `${process.env.VUE_APP_BASE_URI}/group?active=true`;
      this.$http.get(url).then((res) => {
        this.groups = res.data;
        this.setSellected("groups", this.groups);
      });
    },
    getWorkerGroups() {
      let url = `${process.env.VUE_APP_BASE_URI}/group?active=true&workerGroups=true`;
      this.$http.get(url).then((res) => {
        this.workerGroups = res.data;
        this.setSellected("groups", this.workerGroups);
      });
    },
    getUsers() {
      let url = `${process.env.VUE_APP_BASE_URI}/auth/users?active=true&noWorkers=true`;
      this.$http.get(url).then((res) => {
        this.users = res.data;
        this.setSellected("users", this.users);
      });
    },
    setSellected(f, arr) {
      if (this.planning[f]) {
        for (let a of this.planning[f]) {
          arr.forEach((e) => {
            if (e._id.toString() === a._id.toString()) {
              this.$set(e, "selected", true);
            }
          });
        }
      }
    },
    save() {
      this.loading = true;
      let url = `${process.env.VUE_APP_BASE_URI}/planning/${this.planning._id}/groups`;

      this.$http
        .put(url, {
          groups: this.selectedGroups.map((g) => g._id),
          users: this.selectedUsers.map((g) => g._id),
        })
        .then(() => {
          this.$emit("close", true);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    close() {
      this.$emit("close");
    },
  },
  mounted() {
    this.getGroups();
    this.getWorkerGroups();
    this.getUsers();
  },
};
</script>

<style lang="scss" scoped>
.modal {
  overflow: initial;
  max-width: fit-content;
  user-select: none;
  width: calc(100% - 40px);

  header {
    align-items: center;
    background: #00408a;
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
    color: #fff;
    display: flex;
    height: 43px;
    justify-content: space-between;
    padding: 0 13px 0 25px;

    p {
      font-weight: 500;
      text-transform: uppercase;
    }
    > div {
      align-items: center;
      display: flex;
      gap: 7px;
      .tms {
        font-size: 27px;
      }
    }

    .close {
      cursor: pointer;
      &:hover {
        opacity: 0.8;
      }
    }
  }

  > main {
    max-height: calc(70vh - 104px);
    padding: 15px 25px;
    overflow: auto;

    .row {
      display: flex;
      gap: 10px;
      justify-content: space-between;

      > section {
        display: flex;
        flex-direction: column;
        gap: 15px;
        min-width: 320px;
        width: 33%;
      }

      &:last-child {
        margin-top: 6px;
      }
    }
  }

  > footer {
    border-top: 1px solid #70707033;
    margin: 0 auto;
    padding: 12px;
    text-align: center;
    width: calc(100% - 11px);
    button {
      background: #0057bb;
      border: none;
      border-radius: 4px;
      color: #fff;
      cursor: pointer;
      font-size: 13px;
      font-weight: 500;
      height: 36px;
      width: 160px;

      &:disabled {
        cursor: default;
        opacity: 0.8;
      }

      &:hover {
        opacity: 0.8;
      }
    }
  }
}
</style>
